import { FaPhone, FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { getContactAction } from "../constants/helper";

// "Contactar" button shown where the price would be when an ad has no price.
// Rendered as a span (not <a>) because it sits inside cards that are links:
// clicking it opens the phone / email / WhatsApp without opening the ad.
const ContactCta = ({ item, compact = false }) => {
    const contact = getContactAction(item);
    if (!contact) return null;

    const Icon = contact.type === 'email' ? MdEmail : contact.type === 'whatsapp' ? FaWhatsapp : FaPhone;
    const open = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (contact.type === 'whatsapp') window.open(contact.href, '_blank', 'noopener,noreferrer');
        else window.location.href = contact.href;
    };

    return (
        <span
            role="link"
            tabIndex={0}
            title={contact.title}
            className={'contact-cta contact-cta--' + contact.type + (compact ? ' contact-cta--compact' : '')}
            onClick={open}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') open(e); }}
        >
            <span className="contact-cta__icon" aria-hidden="true"><Icon /></span>
            <span>Contactar vendedor</span>
        </span>
    );
};

export default ContactCta;
